module.exports = __webpack_public_path__ + "static/img/index-lun-1.45ad9008.png";